<script lang="ts" setup>
import type { RouteName } from "@/router";

withDefaults(
  defineProps<{
    text: string;
    routeName?: RouteName | null;
    disabled?: boolean;
    bgColor?: "transparent" | "text-light";
  }>(),
  { routeName: null, disabled: false, bgColor: "transparent" }
);

const emit = defineEmits<{
  (e: "btn-click"): void;
}>();
</script>

<template>
  <component
    :is="routeName ? 'router-link' : 'button'"
    v-bind="routeName ? { to: { name: routeName as string } } : {}"
    class="border-primary group text-primary flex w-fit items-center space-x-4 rounded-[30px] border px-4 py-[10px] transition-colors duration-400 md:py-[11.5px]"
    :disabled="!routeName && disabled"
    :class="[
      disabled ? 'cursor-not-allowed opacity-30' : 'cursor-pointer',
      bgColor === 'transparent'
        ? !disabled
          ? 'hover:bg-primary hover:text-text-light hover:border-text-light bg-transparent'
          : 'bg-transparent'
        : '',
      bgColor === 'text-light'
        ? !disabled
          ? 'hover:bg-primary hover:text-text-light hover:border-text-light bg-text-light'
          : 'bg-text-light'
        : '',
    ]"
    @click="!routeName && emit('btn-click')"
  >
    <div class="text-xl leading-[120%] font-semibold md:text-2xl">{{ text }}</div>
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      xmlns="http://www.w3.org/2000/svg"
      class="text-primary h-[21.33px] w-[21.33px] fill-current transition-colors duration-400"
      :class="{ 'group-hover:text-text-light': !disabled }"
    >
      <path
        d="M13.879 5.00652L2.40032 16.4852L0.514703 14.5996L11.9934 3.1209L1.43394 3.1209L1.45751 0.457467H16.5425V15.5424L13.879 15.566L13.879 5.00652Z"
      />
    </svg>
  </component>
</template>
